import { WALL } from '../../Constants/ObjectTypes';
import getItemRules from './getItemRules';

export function isDisabledWallType(configurationData, type, option) {
  if (type === WALL) {
    const rules = getItemRules(configurationData);
    if (rules.disabledWallTypes?.includes(option?.identifier)) {
      return true;
    }
  }
  return false;
}
